import React, { Component } from 'react';
import { Container, Row } from 'reactstrap';

//Import Section Title
import SectionTitle from '../common/section-title';

//Import Service Box
import ServiceBox from './service-box';

class Services extends Component {
	state = {
		services1: [
			{
				title: 'Cloud Solutions',
				icon: 'ti-harddrives',
				desc: 'Data management and database architecture.',
			},
			{
				title: 'Blockchain',
				icon: 'ti-server',
				desc: "Conquer tomorrow's world with the right blockchain technology.",
			},
			{
				title: 'Graphic and UI/UX Design',
				icon: 'ti-palette',
				desc: 'Aesthetically appealing user interfaces and intuitive experiences.',
			},
		],
		services2: [
			{
				title: 'Web Development',
				icon: 'ti-world',
				desc: "Innovative websites and apps that embody your organization's branding.",
			},
			{
				title: 'Artificial Intelligence',
				icon: 'ti-user',
				desc: 'Leverage the power of AI to automate tasks and empower your workforce.',
			},
			{
				title: 'Consultation',
				icon: 'ti-headphone-alt',
				desc: 'Receive guidance or advice towards a technology ready future.',
			},
		],
	};
	render() {
		return (
			<React.Fragment>
				<section
					className={
						this.props.isBgWhite === true ? 'section' : 'section bg-lightgray'
					}
					id="services"
				>
					<Container>
						<SectionTitle title="Services" />
						<Row>
							<ServiceBox services={this.state.services1} />
						</Row>

						<Row>
							<ServiceBox services={this.state.services2} />
						</Row>
					</Container>
				</section>
			</React.Fragment>
		);
	}
}

export default Services;
